module.exports = __webpack_public_path__ + "static/img/6.6023b56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/sp/6.png
// module id = BhrK
// module chunks = 0